import React from 'react'
import { AddCircleIcon, SaveIcon, WarningIcon } from '../icons'

import S from './styled'

const Input = React.forwardRef(({
  name, title, label, text, number,
  onAdd,
  onSave,
  validateOnBlur = true, validate,
  warnEmpty,
  style,
  onAction,
  actionIcon,
  minWidth,
  defaultValue,
  inputStyle,
  inverted,
  className,
  fullWidth,
  disabled,
  error,
  readOnly,
  onKeyPress,
  onKeyDown,
  ...props
}, ref) => {
  const inputProps = (text || number)({
    name,
    validateOnBlur,
    validate,
    defaultValue,
    readOnly,
  })
  return (
    <S.Input style={style} minWidth={minWidth} className={className} fullWidth={fullWidth}>
      {title && <label {...(typeof label === 'function' ? label(name) : {})}>{title}</label>}
      <S.InputContainer error={validate && !!(inputProps.error || error)} inverted={inverted}>
        <input {...inputProps}
          onKeyPress={onKeyPress} onKeyDown={onKeyDown}
          autoComplete="off" ref={ref} disabled={disabled} {...props} style={inputStyle} readOnly={readOnly}/>
        {onAdd && <S.Icon onClick={onAdd}><AddCircleIcon /></S.Icon>}
        {onSave && <S.Icon onClick={onSave}><SaveIcon /></S.Icon>}
        {warnEmpty && !inputProps.value && <S.Icon><WarningIcon /></S.Icon>}
        {onAction && actionIcon && <S.Icon onClick={onAction}>{actionIcon}</S.Icon>}
      </S.InputContainer>
      {
        validate && (inputProps.error || error) && <S.ErrorLabel>{inputProps.error || error}</S.ErrorLabel>
      }
    </S.Input>
  )
})

export default Input
